
import { buscar as buscarPerfil } from '../routes/private/PerfilUsuario/actions'
import { listar as buscarDinamicForms } from '../routes/sistema/DinamicForms/actions'
export const actionsAfterLogin = (user) => (dispatch) => {
    buscarPerfil()(dispatch)
    buscarDinamicForms()(dispatch)
}


// WEBPACK FOOTER //
// ./src/App/functions.js